import { inject } from '@angular/core';
import { ReferrerHttpService } from '@profile/infra';
import { Observable } from 'rxjs';

export class SetReferrerCommandHandler {
  private readonly referrerHttpService: ReferrerHttpService = inject(ReferrerHttpService);

  setReferrer(referrerToken: string): Observable<void> {
    return this.referrerHttpService.setReferrer(referrerToken);
  }
}
